module.exports = __webpack_public_path__ + "img/favorite150.5e98fd7f.png";